import React from 'react';
import {StyledSpinnerContainer} from './styled';

export const LoaderContainer: React.FC = ({children}): JSX.Element => (
  <StyledSpinnerContainer>{children}</StyledSpinnerContainer>
);
